import * as Sentry from '@sentry/browser';

import {RouterStore} from "alpine";
import type { Alpine } from "alpinejs";

export function registerRouterStore(alpine: Alpine) {
    const store: RouterStore = {
        htmlContent: '',
        isLoading: false,
        routes: {
            '': 'pages/home.html',
            'landing': 'pages/landing.html',
            'pouze-pro-dospele': 'pages/adult_only.html',
            'chci-soutezit': 'pages/contest.html',
            'vyhra': 'pages/prize.html',
        },

        async loadPageFromHash() {

            if (this.isLoading) {
                console.warn('Router: Page loading already in progress. Skipping.');
                return;
            }

            this.isLoading = true;

            //const hash = location.hash.replace('#', '') || '';

            const hash = 'landing';

            const url = this.routes[hash] || 'pages/error404.html';

            const view = document.getElementById('router-view');
            view?.classList.remove('fade-enter-active');
            view?.classList.add('fade-enter');

            await new Promise(r => setTimeout(r, 20));

            try {
                Sentry.addBreadcrumb({
                    category: "navigation",
                    message: "go to url:" + hash + " -> fetch: " + url,
                    level: "info",
                })

                const res = await fetch(url);

                if (!res.ok) {
                    throw new Error(`HTTP error! status: ${res.status} for ${url}`);
                }

                this.htmlContent = await res.text();
            } catch(e) {
                Sentry.captureException(e);
                this.htmlContent = '<p>Chyba při načítání.</p>';
            } finally {
                this.isLoading = false;
                await Alpine.nextTick();
                view?.classList.add('fade-enter-active');
            }
        },

        init() {
            this.loadPageFromHash();
            window.addEventListener('hashchange', () => this.loadPageFromHash());
        }
    };

    alpine.store('router', store);
}
